export enum FeatureFlags {
    'DEVELOPMENT' = 'DEVELOPMENT',
    'CANDIDATE_QUESTIONS' = 'CANDIDATE_QUESTIONS',
    'REPORTS' = 'REPORTS',
    'EMAIL_SETTINGS' = 'EMAIL_SETTINGS',
}
